module.exports = __webpack_public_path__ + "static/app-shot-n-1-5-81fbee96d063ea46ee3a36ebecfac6ef.png";